module.exports = __webpack_public_path__ + "img/One-Stop-banner.49d610cd.png";